export const POST_ORDER_CREATION_REQUEST = "POST_ORDER_CREATION_REQUEST";
export const POST_ORDER_CREATION_SUCCESS = "POST_ORDER_CREATION_SUCCESS";
export const POST_ORDER_CREATION_FAILURE = "POST_ORDER_CREATION_FAILURE";
export const FETCH_ORDER_DETAILS_REQUEST = "FETCH_ORDER_DETAILS_REQUEST";
export const FETCH_ORDER_DETAILS_SUCCESS = "FETCH_ORDER_DETAILS_SUCCESS";
export const FETCH_ORDER_DETAILS_FAILURE = "FETCH_ORDER_DETAILS_FAILURE";   
export const REMOVE_ORDER = "REMOVE_ORDER";